import { Typography } from "antd";
import { IconGlyph, IconGrid, IconItem, IconPickerContainer } from "./styles";
import { EVENT_TAG_ICONS, getEventTagIconUrl } from "./constants";

interface IconPickerProps {
    title?: string;
    isRequired?: boolean;
    value?: string;
    onChange?: (iconName: string) => void;
    icons?: string[];
    error?: boolean;
    isDisabled?: boolean;
    style?: React.CSSProperties;
}

const IconPicker = ({
	title,
	isRequired = false,
	value,
	onChange,
	icons = EVENT_TAG_ICONS,
	error = false,
	isDisabled = false,
	style,
}: IconPickerProps) => {
	return (
		<IconPickerContainer style={style}>
			{title && (
				<Typography.Title level={5} style={{ color: "#2e333e" }}>
					{title}
					{isRequired && <span style={{ color: "red" }}>&nbsp;*</span>}
				</Typography.Title>
			)}
			{/* The icons carry no visible name (no tooltip); the file name stays available to screen readers. */}
			<IconGrid $error={error}>
				{icons.map(icon => (
					<IconItem
						key={icon}
						type="button"
						$selected={value === icon}
						disabled={isDisabled}
						aria-label={icon}
						aria-pressed={value === icon}
						onClick={() => onChange?.(icon)}
					>
						<IconGlyph $src={getEventTagIconUrl(icon)} />
					</IconItem>
				))}
			</IconGrid>
		</IconPickerContainer>
	);
};

export default IconPicker;
